import Rapor from "../../../../../components/categories/siakad/lms/rapor/Home";
export default function Home() {
  
  return (
    <Rapor />
  );
}
